/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, useState } from 'react'
import type { JSX } from 'react/jsx-runtime'
import type { ModalContextType, ModalProviderProps } from '@/types'

const ModalContext = createContext<ModalContextType | undefined>(undefined)

export const ModalProvider = ({
  children,
}: ModalProviderProps): JSX.Element => {
  const [isShowCaseModal, setIsShowCaseModal] = useState(false)
  const [isShowSearchModal, setIsShowSearchModal] = useState(false)

  return (
    <ModalContext.Provider
      value={{
        isShowCaseModal,
        isShowSearchModal,
        setIsShowCaseModal,
        setIsShowSearchModal,
        setShowCaseModal: setIsShowCaseModal,
        setShowSearchModal: setIsShowSearchModal,
      }}
    >
      {children}
    </ModalContext.Provider>
  )
}

export const useModal = (): ModalContextType => {
  const context = useContext(ModalContext)

  if (context === undefined) {
    throw new Error('useModal must be used within a ModalProvider')
  }

  return context
}
